import { EmployeeSummaryDto } from './employee-summary-dto.model';


export class MissingThumbDetailsDto implements IMissingThumbDetailsDto {
    eventDate!: Date | undefined;
    inDateTime!: Date | undefined;
    outDateTime!: Date | undefined;
    timings!: string | undefined;
    employee!: EmployeeSummaryDto;
    empLegalName!: string | undefined;
    dayFlag!: string | undefined;

    constructor(data?: IMissingThumbDetailsDto) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.eventDate = _data["eventDate"] ? new Date(_data["eventDate"].toString()) : <any>undefined;
            this.inDateTime = _data["inDateTime"] ? new Date(_data["inDateTime"].toString()) : <any>undefined;
            this.outDateTime = _data["outDateTime"] ? new Date(_data["outDateTime"].toString()) : <any>undefined;
            this.timings = _data["timings"];
            this.employee = _data["employee"] ? EmployeeSummaryDto.fromJS(_data["employee"]) : <any>undefined;
            this.empLegalName = _data["empLegalName"];
            this.dayFlag = _data["dayFlag"];
        }
    }

    static fromJS(data: any): MissingThumbDetailsDto {
        data = typeof data === 'object' ? data : {};
        let result = new MissingThumbDetailsDto();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["eventDate"] = this.eventDate ? this.eventDate.toISOString() : <any>undefined;
        data["inDateTime"] = this.inDateTime ? this.inDateTime.toISOString() : <any>undefined;
        data["outDateTime"] = this.outDateTime ? this.outDateTime.toISOString() : <any>undefined;
        data["timings"] = this.timings;
        data["employee"] = this.employee ? this.employee.toJSON() : <any>undefined;
        data["empLegalName"] = this.empLegalName;
        data["dayFlag"] = this.dayFlag;
        return data; 
    }
}

export interface IMissingThumbDetailsDto {
    eventDate: Date | undefined;
    inDateTime: Date | undefined;
    outDateTime: Date | undefined;
    timings: string | undefined;
    employee: EmployeeSummaryDto;
    empLegalName: string | undefined;
    dayFlag: string | undefined;
}

